var map = {
	"./telaAzulMarinho (1).jpg": 8449,
	"./telaAzulMarinho (1).png": 6391,
	"./telaAzulMarinho (10).png": 8946,
	"./telaAzulMarinho (11).png": 8085,
	"./telaAzulMarinho (2).png": 3322,
	"./telaAzulMarinho (3).png": 3454,
	"./telaAzulMarinho (4).png": 6790,
	"./telaAzulMarinho (5).png": 2230,
	"./telaAzulMarinho (6).png": 8388,
	"./telaAzulMarinho (7).png": 6679,
	"./telaAzulMarinho (8).png": 2949,
	"./telaAzulMarinho (9).png": 4376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7362;